import { createFileRoute } from '@tanstack/react-router';
import ManagerDashboard from '../../components/manager/ManagerDashboard';
import ManagerPortal from '../../components/portals/ManagerPortal';
import { useAuth } from '../../contexts/AuthContext';
import { mockManagerUser } from '../../data/mockData';

export const Route = createFileRoute('/manager/')({
  component: ManagerDashboardRoute,
});

function ManagerDashboardRoute() {
  const { user, isManager } = useAuth();
  const content = <ManagerDashboard user={user && isManager ? user : mockManagerUser} />;
  return <ManagerPortal>{content}</ManagerPortal>;
}
